import { render, staticRenderFns } from "./DefaultPageLayout.vue?vue&type=template&id=6a7c58b3"
import script from "./DefaultPageLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultPageLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultPageLayout.vue?vue&type=style&index=0&id=6a7c58b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports